<template>
  <div class="container_box">
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002399')" prop="ymsWarehouseId">
              <Select v-model="pageParams.ymsWarehouseId" filterable @on-change="changeSelect">
                <Option v-for="item in warehouseList" :key="item.ymsWarehouseId" :value="item.ymsWarehouseId">{{ item.name }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="`${configCharacters()}` + $t('key1004249')" prop="packageCodes">
              <Input type="textarea" v-model.trim="pageParams.packageCodes" :placeholder="$t('key1004982')"></Input>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <div class="filterItem">
              <Form-item :label="$t('key1004983')">
                <local-tabButton :tabButtonList="commodityStatusList" @selectStatus="commodityStatus"></local-tabButton>
              </Form-item>
            </div>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1001180')">
              <Date-picker
                class="wid100P"
                type="datetimerange"
                @on-clear="resetDate"
                @on-change="getDateValue"
                :clearable="clearAble"
                :options="dateOptions"
                format="yyyy-MM-dd HH:mm:ss"
                placement="bottom-end"
                :placeholder="$t('key1000360')"
                :value="payTimeArr">
              </Date-picker>
            </Form-item>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="searchData" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <div class="shipping_method">
      <!--邮件方式-->
      <div class="left_box">
        <div class="option_btn" v-if="!upOrDown" @click="switchBtn">
          <Icon size="20" type="ios-arrow-forward"/>
        </div>
        <shippingMethod
          :upOrDown="upOrDown"
          @switchOption="switchOption"
          @selectCheckBox="selectCheckBox"
          :showCheckbox="true"
          :treeData="treeData">
        </shippingMethod>
      </div>
      <div class="right_box" :style="upOrDown ? 'width: 77%' : 'width: 100%'">
        <!--功能按钮操作区域-->
        <div class="operation_box" :style="upOrDown ? '' : 'padding-left: 35px;'">
          <div class="mr15 sort_options_box">
            <span>{{ $t('key1004046') }}</span>
            <Button-group>
              <Button :type="item.checked ? 'primary' : 'default'"
                v-for="item in sortData"
                @click="clickSortButton(item)"
                :key="item.value">{{ item.label }}
                <Icon type="md-arrow-up" v-if="item.checked && !item.toogle"></Icon>
                <Icon type="md-arrow-down" v-if="item.checked && item.toogle"></Icon>
              </Button>
            </Button-group>
          </div>
          <Dropdown transfer class="mr15" @on-click="clickAssignBatch"
            v-if="getPermission('ymsPickingOrder_create') || getPermission('ymsPickingOrder_batchCreate')">
            <Button type="primary">
              <span>{{ $t('key1004785') }}</span>
              <Icon type="ios-arrow-down"></Icon>
            </Button>
            <DropdownMenu slot="list">
              <DropdownItem name="select" v-if="getPermission('ymsPickingOrder_create')">{{ $t('key1004984') }}</DropdownItem>
              <DropdownItem name="all" v-if="getPermission('ymsPickingOrder_batchCreate')">{{ $t('key1004985') }}</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
        <!--列表区域-->
        <div class="table_box">
          <Table
            border
            highlight-row
            ref="selection"
            :loading="tableLoading"
            max-height="490"
            :columns="tableColumns"
            :data="data"
            @on-selection-change="tableChange">
          </Table>
          <Page
            :transfer="true"
            v-if="!tableLoading"
            :total="total"
            :current="pageParams.pageNum"
            :page-size="pageParams.pageSize"
            :page-size-opts="pageArray"
            show-total
            show-sizer
            show-elevator
            @on-change="changePage"
            placement="top"
            @on-page-size-change="changePageSize">
          </Page>
        </div>
      </div>
    </div>
    <!--生成拣货单弹窗-->
    <createPickListModal
      ref="createPickList"
      :isNeedAssemble="0"
      :parameterObj="handleParameter()"
      @closeSuccess="closeSuccess">
    </createPickListModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import createPickListModal from "@/views/yms/components/wms/exWarehouse/createPickList.vue";
import shippingMethod from "@/components/common/shippingMethod";
import {setConfigCharacters, getEnableWarehouseData, getWarehouseName, getWarehouseId, getDataSetBatchList, getEnumList} from "@/utils/common";

export default {
  name: "generateOrderList",
  mixins: [Mixin],
  components: {
    createPickListModal,
    shippingMethod
  },
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      treeData: [],
      warehouseList: [],
      upOrDown: true,
      platformArr: [],
      pickListSetting: null,
      indeterminateAll: false,
      wareId: getWarehouseId(),
      pageParams: {
        createdEndTime: null,
        createdStartTime: null,
        orderBy: "CT",
        orderSeq: "DESC",
        packageType: null,
        packageCodes: '',
        ymsWarehouseId: 'null',
        pickingExtendList: null,
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      pickingNo: '',
      workType: 'sellStock',
      cacheClickVal: 'CT', // 排序缓存值
      orderSeq: 'DESC',
      selectTableData: [],
      sortData: [
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004037'), value: 'CT', checked: true, toogle: true},
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004979'), value: 'AS', checked: false, toogle: true}
      ],
      tableColumns: [
        {
          type: 'selection',
          width: 70,
          align: 'center',
          fixed: 'left'
        },
        {
          title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000522')}`,
          key: 'packageCode',
          align: 'center',
          minWidth: 230,
          render(h, params) {
            let objLabel = {
              TEMU_S: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004409'),
              TEMU_P: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004410'),
            };
            let packageCode = params.row.packageCode;
            let orderType = params.row.orderType;
            let labelName = objLabel[orderType];
            return h('div', {
              class: 'flex align-items-center justify-content-center'
            }, [
              h('span', packageCode),
              labelName ? h('span', {
                style: {
                  marginLeft: '6px',
                  border: '1px solid #2D8CF0',
                  padding: '1px 4px',
                  borderRadius: '4px',
                  color: '#2D8CF0'
                }
              }, labelName) : ''
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004560'),
          align: 'center',
          minWidth: 140,
          render: (h, params) => {
            if (params.row.productQuantity > 1) {
              return h('div', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000202'));
            } else {
              return h('div', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000203'));
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004435'),
          minWidth: 150,
          align: 'center',
          key: 'orderShippingId'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002390'),
          key: 'warehouseName',
          minWidth: 130,
          align: 'center',
          render(h, params) {
            return h('span', getWarehouseName(v.warehouseList, params.row.ymsWarehouseId));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002332'),
          minWidth: 130,
          align: 'center',
          render(h, params) {
            return h('div', {}, [
              h('span', params.row.buyerCountryCode),
              h('span', params.row.buyerState ? ' / ' : ''),
              h('span', params.row.buyerState),
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000695'),
          minWidth: 130,
          align: 'center',
          key: 'skuQuantity'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004370'),
          align: 'center',
          minWidth: 130,
          sortable: true,
          key: 'productQuantity'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159'),
          align: 'center',
          minWidth: 170,
          sortable: true,
          key: 'createdTime',
          render: (h, params) => {
            return h('span', v.$uDate.getDataToLocalTime(params.row.createdTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'center',
          width: 210,
          fixed: 'right',
          render: (h, params) => {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000296'),
                    show: v.getPermission('ymsPackageInfo_detail'),
                    clickFn: () => {
                      v.pickingNo = params.row.pickingNo;
                      const {href} = v.$router.resolve({
                        path: '/generateOrderDetails',
                        query: {
                          ymsPackageId: params.row.ymsPackageId,
                          where: 'generateOrderList'
                        }
                      });
                      window.open(href, '_blank');
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004785'),
                    show: v.getPermission('ymsPickingOrder_create'),
                    clickFn: () => {
                      v.$refs['createPickList'].initCreatePickListData([], 'single', params.row);
                    }
                  },
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      data: [],
      recordNum: null,
      clearAble: true,
      payTimeArr: [],
      productBrandList: [],
      enumData: [],
      currentIndex: 0
    };
  },
  computed: {
    commodityStatusList() {
      const ENUM_KEY = 'YmsPickingOrderPackageGoodsTypeCoreEnum';
      let list = getEnumList(this.enumData, ENUM_KEY, 'number');
      list.unshift({
        selected: true,
        value: 0,
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
      });
      list.forEach((item,index) => {
        item.selected = index === this.currentIndex;
      });
      return list;
    }
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      let v = this;
      v.warehouseList = [];
      (async () => {
        let enumKeyList = ['YmsPickingOrderPackageGoodsTypeCoreEnum'];
        v.enumData = await getDataSetBatchList(enumKeyList);
        await getEnableWarehouseData(1).then((data) => {
          v.warehouseList = data;
        });
        if (v.warehouseList && v.warehouseList.length) {
          v.pageParams.ymsWarehouseId = v.warehouseList[0].ymsWarehouseId;
          await v.getAllShipMethod();
          await v.searchFn();
        }
      })();
    },
    // 选取商品状态
    commodityStatus(index, value) {
      let v = this;
      v.pageParams.packageType = value;
      v.currentIndex = index;
    },
    // 生成拣货单成功之后更新列表数据
    closeSuccess(value) {
      this.$refs['selection'].selectAll(false);
      this.selectTableData = [];
      if (value == 'update') {
        this.searchFn();
      }
    },
    // 生成拣货单
    clickAssignBatch(val) {
      // 勾选
      if (val === 'select') {
        if (this.selectTableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004980'));
          return false;
        }
        this.$refs['createPickList'].initCreatePickListData(this.selectTableData, val);
      }
      // 所有
      else if (val === 'all') {
        if (this.data.length === 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004981'));
          return false;
        }
        this.$refs['createPickList'].initCreatePickListData([], val);
      }
    },
    // 参数处理
    handleParameter() {
      let obj = JSON.parse(JSON.stringify(this.pageParams));
      obj.orderBy = this.cacheClickVal === '' ? null : this.cacheClickVal;
      obj.packageCodes = this.sepCommasFn(obj.packageCodes);
      obj.ymsWarehouseId = this.pageParams.ymsWarehouseId === 'null' ? null : this.pageParams.ymsWarehouseId;
      return obj;
    },
    // 查询
    searchFn() {
      let v = this;
      v.data = [];
      v.total = 0;
      if (v.getPermission('ymsPackageInfo_queryWaitPickingPackageInfo')) {
        v.tableLoading = true;
        v.axios.put(api.put_ymsPackageInfo_queryWaitPickingPackageInfo, v.handleParameter()).then(res => {
          if (res.data.code === 0) {
            let data = res.data.datas;
            v.data = data.list || [];
            v.total = data.total;
            v.$nextTick(() => {
              v.tableLoading = false;
            });
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 选择仓库
    changeSelect() {
      this.searchData();
      this.getAllShipMethod();
    },
    // 查询按钮
    searchData() {
      this.pageParams.pageNum = 1;
      this.searchFn();
    },
    // 点击排序按钮
    clickSortButton(data) {
      if (data.value === this.cacheClickVal) {
        data.toogle = !data.toogle;
      }
      this.cacheClickVal = data.value;
      if (data.toogle) {
        this.pageParams.orderSeq = 'DESC'; // 降
      } else {
        this.pageParams.orderSeq = 'ASC';
      }
      this.sortData.forEach(function (n) {
        n.checked = data.value === n.value;
      });
      this.searchFn();
      this.getAllShipMethod();
    },
    // 勾选列表数据
    tableChange(data) {
      this.selectTableData = data;
    },
    // 重置创建时间
    resetDate() {
      let v = this;
      v.pageParams.createdStartTime = null;
      v.pageParams.createdEndTime = null;
    },
    // 获取日期返回值
    getDateValue(value) {
      var v = this;
      if (value.length === 0 || !value[0]) {
        v.resetDate();
      } else {
        if (value[0] !== '') {
          let timeList = v.defaultTimePeriod(value);
          v.payTimeArr = v.defaultTimePeriod(value, false);
          v.pageParams.createdStartTime = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
          v.pageParams.createdEndTime = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
        }
      }
    },
    // 展开与收起邮寄方式
    switchBtn() {
      this.upOrDown = !this.upOrDown;
    },
    switchOption(val) {
      this.upOrDown = val;
    },
    // 重置按钮
    reset() {
      this.currentIndex = 0;
      this.commodityStatus(0, null);
      this.$refs['pageParams'].resetFields();
      this.payTimeArr = [];
      this.pageParams.ymsWarehouseId = this.warehouseList[0].ymsWarehouseId;
      this.pageParams.pickingExtendList = null;
      this.pageParams.orderBy = 'CT';
      this.pageParams.orderSeq = 'DESC';
      this.pageParams.pageNum = 1;
      this.pageParams.pageSize = 10;
      this.resetDate();
      this.searchData();
      this.getAllShipMethod();
    },
    // 选中的邮寄方式
    selectCheckBox(arr) {
      let paramsArr = [];
      if (arr.length > 0) {
        arr.map((item) => {
          if (item.shippingMethodId) {
            paramsArr.push({
              logisticsMailCode: item.shippingMethodId
            });
          }
        });
      }
      let list = this.uniqueFunc(paramsArr, 'logisticsMailCode');
      this.pageParams.pickingExtendList = list || null;
      this.searchFn();
    },
    // 获取邮寄方式的数据
    getAllShipMethod() {
      let v = this;
      let obj = {
        createdEndTime: null,
        createdStartTime: null,
        orderBy: "CT",
        orderSeq: "DESC",
        packageType: null,
        packageCodes: [],
        ymsWarehouseId: v.pageParams.ymsWarehouseId,
        pickingExtendList: null,
        isNeedAssemble: 0,
      };
      v.treeData = [];
      v.axios.post(api.post_ymsPackageInfo_querySalesPickingCarriers, obj).then(res => {
        if (res.data.code === 0) {
          let data = res.data.datas || [];
          if (data.length > 0) {
            data.forEach(val => {
              val.title = val.carrierName === null ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004750') : val.carrierName;
              val.expand = true;
              val.pickingNumber = val.count;
              if (val.shippingMethods) {
                val.shippingMethods.forEach(val2 => {
                  val2.title = val2.shippingMethodName === null ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004751') : val2.shippingMethodName;
                  val2.expand = true;
                  val2.pickingNumber = val2.count;
                });
              }
              val.children = val.shippingMethods || [];
            });
            if (data.length !== 0) {
              v.treeData = [
                {
                  title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110'),
                  expand: true,
                  pickingNumber: 0,
                  children: []
                }
              ];
              v.treeData[0].pickingNumber = data.reduce((a, b) => {
                return a + b.count;
              }, 0);
              v.treeData[0].children = data;
            }
          }
        }
      });
    },
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.searchFn();
        v.pageParamsStatus = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.setting-icon {
  cursor: pointer;
  position: relative;
  top: 6px;
}

.shipping_method {
  width: 100%;
  position: relative;
  display: flex;
  justify-content: space-around;

  .left_box {
    position: relative;

    .option_btn {
      position: absolute;
      top: 0;
      left: 0;
      height: 56px;
      background-color: #2b85e4;
      color: #fff;
      width: 25px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
  }
}
</style>
